import {} from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import { AppAction } from '../../../store';
import { updateObject } from '../../utils';
import * as actionTypes from '../constants/actionTypes';
import {
  CheckerForSmsUser,
  InitializeUpdateForRelatedUsers,
  RemainderNotificationResponse,
  RemainderNotificationUser,
  SmsUpdatesResponse,
  UnreadMessageResponse,
  UnreadMessageUser,
} from '../../models';

export interface WebSocketState {
  remainderNotificationMessage: RemainderNotificationResponse | null;
  unreadMessage: UnreadMessageResponse | null;
  smsMessage: SmsUpdatesResponse | null;
  bufferOfMessageToSend: RemainderNotificationUser[] | CheckerForSmsUser[] | UnreadMessageUser[] | InitializeUpdateForRelatedUsers[];
}

const initialState: WebSocketState = {
  remainderNotificationMessage: null,
  unreadMessage: null,
  smsMessage: null,
  bufferOfMessageToSend: [],
};

const setRemainderNotificationMessage = (state: WebSocketState, action: AppAction<RemainderNotificationResponse>) => {
  return updateObject(state, {
    remainderNotificationMessage: action.data,
  } as WebSocketState);
};

const setUnreadMessage = (state: WebSocketState, action: AppAction<UnreadMessageResponse>) => {
  return updateObject(state, {
    unreadMessage: action.data,
  } as WebSocketState);
};

const setSmsMessage = (state: WebSocketState, action: AppAction<SmsUpdatesResponse>) => {
  return updateObject(state, {
    smsMessage: action.data,
  } as WebSocketState);
};

const sendMessage = (
  state: WebSocketState,
  action: AppAction<RemainderNotificationUser | CheckerForSmsUser | UnreadMessageUser | InitializeUpdateForRelatedUsers>,
) => {
  return updateObject(state, {
    bufferOfMessageToSend: [...state.bufferOfMessageToSend, action.data],
  } as WebSocketState);
};

const clearBufferOfMessageToSend = (
  state: WebSocketState,
  action: AppAction<RemainderNotificationUser[] | CheckerForSmsUser[] | UnreadMessageUser[] | InitializeUpdateForRelatedUsers[]>,
) => {
  return updateObject(state, {
    bufferOfMessageToSend: action.data,
  } as WebSocketState);
};

const addMessageToBuffer = (
  state: WebSocketState,
  action: AppAction<RemainderNotificationUser | CheckerForSmsUser | UnreadMessageUser | InitializeUpdateForRelatedUsers>,
) => {
  return updateObject(state, {
    bufferOfMessageToSend: [...state.bufferOfMessageToSend, action.data],
  } as WebSocketState);
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.WEB_SOCKET_SET_REMAINDER_NOTIFICATION_MESSAGE:
      return setRemainderNotificationMessage(state, action as AppAction<RemainderNotificationResponse>);

    case actionTypes.WEB_SOCKET_SET_UNREAD_MESSAGE:
      return setUnreadMessage(state, action as AppAction<UnreadMessageResponse>);

    case actionTypes.WEB_SOCKET_SET_SMS_MESSAGE:
      return setSmsMessage(state, action as AppAction<SmsUpdatesResponse>);

    case actionTypes.WEB_SOCKET_SEND_MESSAGE:
      return sendMessage(
        state,
        action as AppAction<RemainderNotificationUser | CheckerForSmsUser | UnreadMessageUser | InitializeUpdateForRelatedUsers>,
      );

    case actionTypes.WEB_SOCKET_CLEAR_BUFFER_OF_MESSAGE_TO_SEND:
      return clearBufferOfMessageToSend(
        state,
        action as AppAction<RemainderNotificationUser[] | CheckerForSmsUser[] | UnreadMessageUser[] | InitializeUpdateForRelatedUsers[]>,
      );

    case actionTypes.WEB_SOCKET_ADD_MESSAGE_TO_BUFFER:
      return addMessageToBuffer(
        state,
        action as AppAction<RemainderNotificationUser | CheckerForSmsUser | UnreadMessageUser | InitializeUpdateForRelatedUsers>,
      );

    default:
      return state;
  }
};

export default reducer;
